export default __webpack_public_path__ + "static/media/zorba8.a4663410.jpg";